import { STATUS_MAPPING } from '../constants/stages.constants';

export const normalizeText = (text: string): string => {
  if (!text) return '';
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove accents
    .trim();
};

export const getStageFromStatus = (status: string): number => {
  if (!status) return 10;
  
  const statusNormalized = normalizeText(status);
  
  // Exact matches first (both normalized)
  for (const [key, stageId] of Object.entries(STATUS_MAPPING)) {
    const keyNormalized = normalizeText(key);
    if (keyNormalized === statusNormalized) {
      return stageId;
    }
  }
  
  // Wildcard matches - prefix and suffix
  for (const [key, stageId] of Object.entries(STATUS_MAPPING)) {
    const keyNormalized = normalizeText(key);
    
    // Handle wildcard prefix (starts with *)
    if (keyNormalized.startsWith('*')) {
      const pattern = keyNormalized.substring(1); // Remove *
      if (statusNormalized.endsWith(pattern)) {
        return stageId;
      }
    }
    
    // Handle wildcard suffix (ends with *)
    if (keyNormalized.endsWith('*')) {
      const pattern = keyNormalized.substring(0, keyNormalized.length - 1); // Remove *
      if (statusNormalized.startsWith(pattern)) {
        return stageId;
      }
    }
  }
  
  // Default to stage 10 if no match
  return 10;
};